import React, { FC } from 'react';
import SvgIcon from './SvgIcon';

const PlusIcon: FC = () => {
    return (
        <SvgIcon viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.3105 4.6543V16.41"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.43359 10.5312H16.1893"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

export default PlusIcon;
